export default "__VITE_ASSET__IqCjSfS4__"